import React from 'react';

import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import { FaPlusCircle, FaMinusCircle } from 'react-icons/fa';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import Button from '@mui/material/Button';
import noImage from './../images/noImage.png';
import Client from './Client';
import DropDown from './DropDown';
import BackOfficeConfig from './../Config';
import swal from 'sweetalert';

const VAL_COL_WIDTH = 100;

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#273442',
    color: theme.palette.common.white,
    paddingLeft: '4px',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    paddingLeft: '4px',
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': { backgroundColor: theme.palette.action.hover },
  '&:last-child td, &:last-child th': { border: 0 },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class KSubCategoriesTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      client: new Client('none'),
      edit: {}, // map: line iref -> bool
      parentSubCategories: [],
      options: {},
      canvas: null,
      saveURL: '',
      parentIref: '',
      showConfirm: false,
      removeIref: '',
      subCategories: [],
      subCategories_select: [],
      addNew: false,
    };

    this.sendChangedState = this.sendChangedState.bind(this);
    this.saveBack = this.saveBack.bind(this);
    this.changeValue = this.changeValue.bind(this);
    this.changePriceType = this.changePriceType.bind(this);
    this.editor = React.createRef();
    this.handleEditClick = this.handleEditClick.bind(this);
    this.changeName = this.changeName.bind(this);
    this.toggleAdd = this.toggleAdd.bind(this);
    this.removeSubCategory = this.removeSubCategory.bind(this);
    this.removeConfirm = this.removeConfirm.bind(this);
    this.removeCancel = this.removeCancel.bind(this);
    this.showConfirmDialog = this.showConfirmDialog.bind(this);
    this.getSubCategories = this.getSubCategories.bind(this);
    this.changeSubCategory = this.changeSubCategory.bind(this);
    this.pushData = this.pushData.bind(this);
  }

  // ---------- lifecycle ----------
  componentDidMount() {
    const rows = this.props.parentSubCategories || this.props.subCategories || [];
    this.setState({ parentSubCategories: rows });

    const editMap = {};
    rows.forEach(el => { if (el?.iref) editMap[el.iref] = false; });
    this.setState({ edit: editMap });

    if (this.props.saveURL) this.setState({ saveURL: this.props.saveURL });
    if (this.props.parentIref) this.setState({ parentIref: this.props.parentIref });

    this.getSubCategories();
  }

  componentDidUpdate(prevProps) {
    if (prevProps === this.props) return;

    if (prevProps.parentSubCategories !== this.props.parentSubCategories ||
        prevProps.subCategories !== this.props.subCategories) {
      const rows = this.props.parentSubCategories || this.props.subCategories || [];
      this.setState({ parentSubCategories: rows });
      const editMap = {};
      rows.forEach(el => { if (el?.iref) editMap[el.iref] = false; });
      this.setState({ edit: editMap });
    }
    if (this.props.saveURL && prevProps.saveURL !== this.props.saveURL) this.setState({ saveURL: this.props.saveURL });
    if (this.props.parentIref && prevProps.parentIref !== this.props.parentIref) this.setState({ parentIref: this.props.parentIref });
  }

  sendChangedState() {}

  getSubCategories () {
    let queryData = {isForSale: 1}; // add { category: someIref } if you need to filter
    let data = this.state.client.getProductsSubCategories(queryData);
    if (data) {
      let subCategories = {};
      for (let i = 0; i < data.productSubCategories.length; i++) {
        subCategories[data.productSubCategories[i].iref] = {
          name:  data.productSubCategories[i].name,
          image: data.productSubCategories[i].image
        };
      }
      this.setState({ subCategories_select: subCategories });
      this.setState({ subCategories: data.productSubCategories });
    }
  }

  saveBack() {} // not used here

  pushData(iref) {
    // Find the row we’re saving
    const row = (this.state.parentSubCategories || []).find(sc => sc.iref === iref);
    if (!row) {
      swal("Error", "Add/Update Sub Category failed !", "error");
      return;
    }

    const subIref = row.productSubCategory?.iref || row.subCategoryIref || "";
    const fullSubcat = (this.state.subCategories || []).find(
      sc => sc.iref === subIref
    );
    const categoryIref = fullSubcat?.category?.iref || "";

    const payload = {
      iref: row.iref || "",
      name: row.name || "",
      priceType: Number(row.priceType || 0),
      priceValue: Number(row.priceValue || 0),
      parentIref: this.state.parentIref || this.props.parentIref || "",
      subCategoryIref: row.productSubCategory?.iref || row.subCategoryIref || "", // << KEY FIELD
      ...(categoryIref ? { categoryIref } : {}),
    };

    // Guard to avoid PCMB-250
    if (!payload.subCategoryIref) {
      swal("Error", "Select a Sub Category first.", "error");
      return;
    }

    const rdata = this.state.client.pushData(this.state.saveURL, payload);

    if (!rdata) {
      swal("Error", "Add/Update Sub Category failed !", "error");
      return;
    }

    // Handle both styles of backend replies (Feedback-style or full row)
    const isOk = (rdata.status ? rdata.status === "OK" : true);

    if (!isOk) {
      const msg = rdata.message || "Add/Update Sub Category failed !";
      swal("Error", msg, "error");
      return;
    }

    // Try to reflect the change locally; if the API returned a new iref, use it
    this.setState(prev => {
      const rows = [...(prev.parentSubCategories || [])];
      const idx = rows.findIndex(x => x.iref === iref);
      if (idx >= 0) {
        // If server returned a full row, replace it; otherwise minimally patch the iref
        if (rdata && rdata.iref && rows[idx].iref === "newSubCategory") {
          rows[idx] = { ...rows[idx], iref: rdata.iref };
        }
      }
      return { parentSubCategories: rows };
    });

    // Close edit for this row and finish
    this.handleEditClick(iref);
    swal("Success", "Successfully added/modified Sub Category !", "success", {
      buttons: false,
      timer: 2000,
    }).then(() => {
      this.setState({ addNew: false, somethingHasChanged: false });
      if (typeof this.props.subCategoryUpdated === "function") {
        this.props.subCategoryUpdated(); // let parent reload the latest data
      }
    });
  }

  changeName(e) {
    const rows = [...this.state.parentSubCategories];
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].iref === e.target.id) { rows[i].name = e.target.value; break; }
    }
    this.setState({ parentSubCategories: rows });
  }

  changeValue(e) {
    const val = e.target.value;
    const id = e.target.id; // line iref
    const rows = [...this.state.parentSubCategories];
    for (let i = 0; i < rows.length; i++) { if (rows[i].iref === id) { rows[i].priceValue = val; break; } }
    this.setState({ parentSubCategories: rows });
  }

  changePriceType(iref, v) {
    const val = Number(v?.target?.value ?? v);
    const rows = [...this.state.parentSubCategories];
    for (let i = 0; i < rows.length; i++) { if (rows[i].iref === iref) { rows[i].priceType = val; break; } }
    this.setState({ parentSubCategories: rows });
  }

  handleEditClick(lineIref) {
    const uEdit = { ...this.state.edit };
    uEdit[lineIref] = !uEdit[lineIref];
    this.setState({ edit: uEdit });
  }

  toggleAdd() {
    const addNow = !this.state.addNew;
    const rows = [...this.state.parentSubCategories];
    const edit = { ...this.state.edit };

    if (addNow) {
      const newRow = {
        iref: 'newSubCategory',
        productSubCategory: {},
        name: '',
        priceType: 0,
        priceValue: 0,
      };
      rows.unshift(newRow);
      edit['newSubCategory'] = true;
    } else {
      if (rows.length > 0 && rows[0].iref === 'newSubCategory') {
        rows.shift();
        delete edit['newSubCategory'];
      }
    }
    this.setState({ addNew: addNow, parentSubCategories: rows, edit });
  }

  removeSubCategory(iref) {
    if (iref === 'newSubCategory') {
      this.toggleAdd();
      if (typeof this.props.subCategoryUpdated === 'function') this.props.subCategoryUpdated();
      return;
    }

    const rows = [...this.state.parentSubCategories];
    const edit = { ...this.state.edit };
    const payload = { iref };

    const rdata = this.state.client.pushData(this.props.removeURL || this.state.removeURL, payload);
    if (rdata) {
      if (rdata.status === 'OK') {
        const idx = rows.findIndex(sc => sc.iref === iref);
        if (idx >= 0) rows.splice(idx, 1);
        delete edit[iref];
        this.setState({ parentSubCategories: rows, edit });
        this.handleEditClick(iref);
        swal('Success', 'Successfully removed Sub Category !', 'success', { buttons: false, timer: 2000 })
          .then(() => {
            if (typeof this.props.subCategoryUpdated === 'function') this.props.subCategoryUpdated();
            this.setState({ somethingHasChanged: false });
          });
      } else {
        if (rdata.message) this.setState({ errorMessage: rdata.message });
        swal('Error', 'Remove Sub Category failed !', 'error');
      }
    }
  }

  showConfirmDialog(iref) { this.setState({ showConfirm: true, removeIref: iref }); }
  removeConfirm() {
    const removeIref = this.state.removeIref;
    this.removeSubCategory(removeIref);
    this.setState({ showConfirm: false, removeIref: '' });
  }
  removeCancel() { this.setState({ showConfirm: false, removeIref: '' }); }

  changeSubCategory(v, parentSubCategory_iref) {
    const chosenIref = typeof v === 'object' ? (v?.target?.value ?? v?.key ?? v) : v;
    const rows = [...this.state.parentSubCategories];
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].iref === parentSubCategory_iref) {
        for (let k = 0; k < this.state.subCategories.length; k++) {
          if (this.state.subCategories[k].iref === chosenIref) {
            const sc = this.state.subCategories[k];
            rows[i].productSubCategory = sc;
            rows[i].productCategory = sc.productCategory || sc.pCategory  || null;
            break;
          }
        }
        if (rows[i].iref === 'newSubCategory') {
          rows[i].name = '';
          rows[i].priceType = 0;
          rows[i].priceValue = 0;
        }
        break;
      }
    }
    this.setState({ parentSubCategories: rows, somethingHasChanged: true });
  }

  // ---------- render ----------
  render() {
    const rows = this.state.parentSubCategories || [];

    const parentSubCategoriesObj = rows.map((parentSubCategory, idx) => {
      const showConfirm = this.state.showConfirm && this.state.removeIref === parentSubCategory.iref;

      // label + show/hide value: use CATEGORY enum and numeric coercion
      let priceType = 'Unknown';
      const priceTypeNum = Number(parentSubCategory.priceType);
      if (parentSubCategory.priceType !== undefined) {
        priceType = BackOfficeConfig.PRODUCT_COMBO_PRODCUT_TYPES_DEF[priceTypeNum];
      }
      const showValue = priceTypeNum === 2; // 2 = Set value

      // subcategory visible fields
      let subCategory_name = '';
      let subCategory_iref = '';
      let subCategoryImage = noImage;

      if (parentSubCategory && parentSubCategory.productSubCategory) {
        subCategory_iref = parentSubCategory.productSubCategory.iref;
        subCategory_name = parentSubCategory.productSubCategory.name;

        const rawImage = parentSubCategory.productSubCategory.image;
        if (typeof rawImage === 'string' && rawImage.trim() !== '') {
          const lastDot = rawImage.lastIndexOf('.');
          if (lastDot > -1) {
            const base = rawImage.slice(0, lastDot);
            const ext = rawImage.slice(lastDot + 1);
            subCategoryImage = `${base}_s.${ext}`;
          } else {
            // no extension? just use the raw path
            subCategoryImage = rawImage;
          }
        }
      }

      const rowKey =
        (parentSubCategory && parentSubCategory.iref) ||
        (parentSubCategory && parentSubCategory.productSubCategory && parentSubCategory.productSubCategory.iref) ||
        `subcat-row-${idx}`;
      return (
        <TableRow key={rowKey}>
          <StyledTableCell>
            {this.state.edit[parentSubCategory.iref] ? (
              <DropDown
                name="Sub Category"
                id={parentSubCategory.iref}
                key={parentSubCategory.iref}
                value={subCategory_iref !== undefined ? subCategory_iref : ''}
                doptions={this.state.subCategories_select}
                hasIcons={true}
                minWidth={180}
                maxWidth={180}
                onDark={false}
                onChangeFunction={(v) => this.changeSubCategory(v, parentSubCategory.iref)}
                marginTop={8}
                marginLeft={0}
                margin={0}
                error={this.state.subcategory_valid === false}
              />
            ) : (
              <IconButton aria-label={subCategory_name} title={subCategory_name}>
                <Avatar alt={subCategory_name} src={subCategoryImage} sx={{ width: 48, height: 48 }} />
              </IconButton>
            )}
          </StyledTableCell>

          <StyledTableCell>
            {subCategory_name}
          </StyledTableCell>

          <StyledTableCell>
            {this.state.edit[parentSubCategory.iref] ? (
              <TextField
                id={parentSubCategory.iref}
                label="Name in Combo"
                value={parentSubCategory.name || ''}
                variant="outlined"
                onChange={this.changeName}
                sx={{ minWidth: '90%', marginTop: 1 }}
                onFocus={(event) => { event.target.select(); }}
                inputProps={{ maxLength: '100' }}
              />
            ) : (
              parentSubCategory.name
            )}
          </StyledTableCell>

          <StyledTableCell>
            {this.state.edit[parentSubCategory.iref] ? (
              <DropDown
                id={parentSubCategory.iref}
                name="Price type"
                value={parentSubCategory.priceType !== undefined ? parentSubCategory.priceType : ''}
                doptions={BackOfficeConfig.PRODUCT_COMBO_PRODCUT_TYPES_DEF}
                hasIcons={false}
                minWidth={180}
                maxWidth={180}
                onDark={false}
                onChangeFunction={(v) => this.changePriceType(parentSubCategory.iref, v)}
                marginTop={10}
                marginLeft={7}
                margin={0}
              />
            ) : (
              priceType
            )}
          </StyledTableCell>

          <StyledTableCell>
            {showValue ? (
              this.state.edit[parentSubCategory.iref] ? (
                <TextField
                  id={parentSubCategory.iref}
                  label="Value"
                  value={parentSubCategory.priceValue || ''}
                  variant="outlined"
                  onChange={this.changeValue}
                  sx={{ minWidth: VAL_COL_WIDTH, marginTop: 1 }}
                  onFocus={(event) => { event.target.select(); }}
                  inputProps={{ maxLength: '100' }}
                />
              ) : (
                parentSubCategory.priceValue
              )
            ) : (
              ''
            )}
          </StyledTableCell>

          <StyledTableCell align="right" sx={{ padding: '1px' }}>
            <IconButton aria-label="settings" id={'ib-' + subCategory_iref} onClick={() => { this.handleEditClick(parentSubCategory.iref); }}>
              <EditIcon id={subCategory_iref} sx={{ color: this.state.edit[parentSubCategory.iref] ? '#8f241d' : '#e3e3e5' }} />
            </IconButton>

            {this.state.edit[parentSubCategory.iref] ? (
              <IconButton aria-label="settings" id={subCategory_iref} onClick={() => { this.pushData(parentSubCategory.iref); }}>
                <SaveIcon sx={{ color: '#4287f5' }} />
              </IconButton>
            ) : ''}

            {this.state.edit[parentSubCategory.iref] ? (
              <IconButton aria-label="settings" id={subCategory_iref} onClick={() => { this.showConfirmDialog(parentSubCategory.iref); }}>
                <DeleteForeverIcon sx={{ color: '#8f241d' }} />
              </IconButton>
            ) : ''}

            <Dialog
              open={showConfirm}
              TransitionComponent={Transition}
              keepMounted
              onClose={this.removeCancel}
              aria-describedby="alert-dialog-slide-description"
            >
              <DialogTitle>{'Remove product ?'}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-slide-description">
                  This action will NOT delete the sub category ! This sub category will only be detached from the combo.
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.removeCancel}>No</Button>
                <Button onClick={this.removeConfirm}>Yes</Button>
              </DialogActions>
            </Dialog>
          </StyledTableCell>
        </TableRow>
      );
    });

    return (
      <Box sx={{ display: 'flex', flexDirection: 'row', textAlign: 'middle', justifyContent: 'center', alignItems: 'center', paddingTop: '2px' }}>
        <Table sx={{ minWidth: 700, textAlign: 'middle', justifyContent: 'center' }} aria-label="customized table">
          <TableHead>
            <TableRow>
              <StyledTableCell>
                <IconButton aria-label="Add SubCategory" title="Add SubCategory" onClick={this.toggleAdd}>
                  <Avatar alt="Add SubCategory" sx={{ width: 24, height: 24, color: '#273442' }}>
                    {this.state.addNew ? <FaMinusCircle /> : <FaPlusCircle />}
                  </Avatar>
                </IconButton>
                SubCategory
              </StyledTableCell>
              <StyledTableCell align="left">Name</StyledTableCell>
              <StyledTableCell align="left">Name in Combo</StyledTableCell>
              <StyledTableCell sx={{width: 180}} align="left">Price Type</StyledTableCell>
              <StyledTableCell sx={{width: VAL_COL_WIDTH}} align="left">Value</StyledTableCell>
              <StyledTableCell align="right">Action</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>{parentSubCategoriesObj}</TableBody>
        </Table>
      </Box>
    );
  }
}

export default KSubCategoriesTable;